import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ClerkProvider } from '@clerk/clerk-react';
import App from './App';
import './styles/global.css';
import './i18n';

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;
const USE_MOCKS = import.meta.env.VITE_USE_MOCKS === '1';
// Phase 4d (FE 联调测试模式): Clerk shim ON + MSW OFF, so the cockpit hits a
// real BE (DEMO_AUTO_USER=1 on the BE bypasses Clerk JWT verification).
// Activated together with VITE_USE_MOCKS=1 + VITE_DEMO_CLERK_ONLY=1; the vite
// alias is conditional on USE_MOCKS so this also requires USE_MOCKS=1.
const SKIP_MSW = import.meta.env.VITE_DEMO_CLERK_ONLY === '1';

const root = ReactDOM.createRoot(document.getElementById('root')!);

const renderApp = () => {
  root.render(
    <React.StrictMode>
      <ClerkProvider
        publishableKey={PUBLISHABLE_KEY ?? 'pk_demo'}
        signInUrl="/auth"
        signUpUrl="/auth/sign-up"
        signInFallbackRedirectUrl="/auth/callback"
        signUpFallbackRedirectUrl="/auth/callback"
      >
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ClerkProvider>
    </React.StrictMode>,
  );
};

const renderClerkMissing = () => {
  root.render(
    <div style={{ maxWidth: 640, margin: '120px auto', padding: '0 24px', fontFamily: 'Inter, system-ui, sans-serif', color: '#1F1A14' }}>
      <h1 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 36, fontWeight: 500, marginBottom: 16 }}>
        Clerk publishable key missing
      </h1>
      <p style={{ color: '#6B6356', lineHeight: 1.6, marginBottom: 24 }}>
        Copy <code style={{ background: '#F5F2EB', padding: '2px 6px', borderRadius: 4 }}>.env.example</code> →{' '}
        <code style={{ background: '#F5F2EB', padding: '2px 6px', borderRadius: 4 }}>.env.local</code>, then set{' '}
        <code style={{ background: '#F5F2EB', padding: '2px 6px', borderRadius: 4 }}>VITE_CLERK_PUBLISHABLE_KEY</code>.
      </p>
      <p style={{ color: '#6B6356', lineHeight: 1.6 }}>
        Or run <code style={{ background: '#F5F2EB', padding: '2px 6px', borderRadius: 4 }}>npm run dev:demo</code> to start with mocked Clerk + backend.
      </p>
    </div>,
  );
};

if (USE_MOCKS && !SKIP_MSW) {
  // Demo mode: boot MSW first, then render. Clerk is shimmed via vite alias.
  void (async () => {
    const { startMocks } = await import('./mocks/browser');
    await startMocks();
    renderApp();
  })();
} else if (USE_MOCKS && SKIP_MSW) {
  // FE↔BE 联调 mode: Clerk shim ON (no real OAuth), MSW OFF (real BE answers
  // /api/v1/* — caller must have BE running with DEMO_AUTO_USER=1).
  renderApp();
} else if (!PUBLISHABLE_KEY || PUBLISHABLE_KEY === 'pk_test_REPLACE_ME') {
  renderClerkMissing();
} else {
  renderApp();
}
